<ng-container
  *ngIf="cs.vm$ | async as vm"
  [dgxGaContainer]="{ eventCategory: 'personal details form' }"
>
  <form
    *ngIf="vm.form as form"
    (submitted)="onFormSubmit($event)"
    [dgxGaFormSubmit]="{
      eventAction: 'continue',
      eventLabel: 'continue',
      marketingPreferences: vm.marketingPreferencesValue
    }"
    [dgxTestHook]="testHooks.Form"
    [formGroup]="form"
    class="marketing-preferences-form"
    dgxFormSubmit
  >
    <dgx-form-row [inline]="true" class="marketing-preferences-form__form-row">
      <dgx-form-field
        [dgxFormField]="vm.cmsData.marketingPreferenceEmailField"
        [dgxTestHook]="testHooks.MarketingPreferenceEmailCheckbox"
        formControlName="marketingPreferenceEmail"
      >
        <dgx-form-checkbox [dgxQmSanitise]="'block'" [size]="'medium'" />
      </dgx-form-field>

      <dgx-form-field
        [dgxFormField]="vm.cmsData.marketingPreferenceTelephoneField"
        [dgxTestHook]="testHooks.MarketingPreferenceTelephoneCheckbox"
        formControlName="marketingPreferenceTelephone"
      >
        <dgx-form-checkbox [dgxQmSanitise]="'block'" [size]="'medium'" />
      </dgx-form-field>

      <dgx-form-field
        [dgxFormField]="vm.cmsData.marketingPreferencePostField"
        [dgxTestHook]="testHooks.MarketingPreferencePostCheckbox"
        formControlName="marketingPreferencePost"
      >
        <dgx-form-checkbox [dgxQmSanitise]="'block'" [size]="'medium'" />
      </dgx-form-field>
    </dgx-form-row>

    <dgx-form-row class="marketing-preferences-form__form-row">
      <dgx-form-submit-button class="marketing-preferences-form__submit-button">
        {{ 'MARKETING_PREFERENCES_FORM_SUBMIT_BUTTON' | translate }}
      </dgx-form-submit-button>
    </dgx-form-row>
  </form>
</ng-container>
